module.exports = __webpack_public_path__ + "static/media/account.684b823d.svg";